<template>
  <transition>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="page-title-box">
            <div class="page-title-right float-left">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <a href="javascript: void(0);">Become A Seller</a>
                </li>
                <li class="breadcrumb-item active">Become A Seller List</li>
              </ol>
            </div>
            <div class="page-title-right float-right"> 
              <!-- <a
                href="javascript:void(0);"
                @click="toggleModal"
                class="btn btn-primary mb-2 mr5"
                ><i class="mdi mdi-plus-circle me-2"></i> Add New</a
              >  -->
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12"> 
          <div class="card">
            <div class="card-body">
              <Datatable
                :columns="columns"
                :sortKey="tableData.sortKey"
                @sort="sortBy"
                v-if="!loading"
              >
                <template #header>
                  <div class="tableFilters" style="margin-bottom: 10px">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="control" style="float: left">
                          <span style="float: left; margin-right: 10px; padding: 7px 0px"
                            >Show
                          </span>
                          <div class="select" style="float: left">
                            <select
                              class="form-select"
                              v-model="tableData.length"
                              @change="fetchItems()"
                            > 
                              <option value="5" selected="selected">5</option>
                              <option value="10" selected="selected">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                          </div>
                          <span style="float: left; margin-left: 10px; padding: 7px 0px">
                            Entries</span
                          >
                        </div>
                      </div>

                      <div class="col-md-2"></div>
                      <div class="col-md-4">
                        <input
                          type="text"
                          class="form-control"
                          style="float: right"
                          v-model="tableData.search"
                          placeholder="Search..."
                          @input="fetchItems()"
                        />
                      </div>
                    </div>
                  </div>
                </template> 
                <template #body>
                  <tbody v-if="items.length > 0">
                    <tr class="border" v-for="(item, i) in items" v-if="items.length > 0">
                      <td>{{ item.phone_number }}</td>
                      <td>{{ item.title }}</td>                        
                      <td>{{ item.description }}</td>                        
                      <td>{{ item.created_by ? item.created_by.email : '' }}</td>                        
                      <td><a
                              href="javascript:void(0);"
                              class="dropdown-item text-danger"
                              @click="deleteItem(item)"
                              ><i class="mdi mdi-delete-outline me-1"></i>Remove</a
                            ></td>                        
                       
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="3">No Data Available Here!</td>
                    </tr>
                  </tbody>
                </template>
                <template #footer>
                  <Pagination
                    :pagination="pagination"
                    :language="lang"
                    @onChangePage="setPage"
                  >
                  </Pagination>
                </template>
              </Datatable>
              <div class="tab-pane show active" v-if="loading">
                <div class="row">
                  <div class="col-md-5"></div>
                  <div class="col-md-2">
                    <img
                      src="../../assets/image/loading.gif"
                      alt="Loading..."
                      style="width: 130px"
                    />
                  </div>
                  <div class="col-md-5"></div>
                </div>
              </div>
            </div>
            <!-- end card body-->
          </div>
          <!-- end card -->
        </div>
        <!-- end col-->
      </div>

      <Modal @close="toggleModal" :modalActive="modalActive">
        <div class="modal-content scrollbar-width-thin product-add-modal">
          <div class="modal-header">
            <h5>Add New Coupon</h5>
            <button @click="toggleModal" type="button" class="btn btn-default">X</button>
          </div>
          <form @submit.prevent="submitForm()" enctype="multipart/form-data">
            <div class="modal-body">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-3">
                    <div class="mb-3">
                      <label class="form-label" for="name">Title*</label>
                      <input
                        type="text"
                        class="form-control border" 
                        v-model="form.title"
                        placeholder="Title"
                      />
                      <div class="invalid-feedback" v-if="errors.title">
                        {{ errors.title[0] }}
                      </div>
                    </div>
                  </div> 
                  <div class="col-md-3">
                    <div class="mb-3">
                      <label class="form-label" for="description">Description*</label>
                      <input
                        type="text"
                        class="form-control border" 
                        v-model="form.description"
                        placeholder="Description"
                      />
                      <div class="invalid-feedback" v-if="errors.description">
                        {{ errors.description[0] }}
                      </div>
                    </div>
                  </div>   
                </div> 

              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-success" :disabled="disabled">
                <span v-show="isSubmit">
                  <svg v-show="isSubmit" class="spinner" width="20px" height="20px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                   <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                  </svg> &nbsp;</span
                >{{ btn }}
              </button> 
            </div>
          </form>
        </div>
      </Modal>     
    </div>
  </transition>
</template>
<script> 
import Modal from "./../helper/Modal";
import { ref } from "vue";
import Form from "vform";
import axios from "axios"; 
import Datatable from "@/components/Datatable.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "Coupons",
  components: {
    Modal,
    Datatable,
    Pagination,
  },
  props: {
    language: {
      type: Object,
      default: () => {
        return {
          lengthMenu: null,
          info: null,
          zeroRecords: null,
          search: null,
        };
      },
    },
  },
  data() {
    return {
      editor: null,
      barcodeOprions: { lineColor: "#0000FF" },
      sSubmit: false,
      showModal: false,
      editMode: false,
      disabled: false,
      loading: true,
      errors: {}, 
      btn: "Create",
      isShow: false,
      showModal: false,
      errors: {},
      items: [],
      isValid: true,   
      value: null,  
        form: new Form({
        id: '',
        phone_number:'', 
        title:'', 
        description:'', 
      }),  
      columns: [
        {
          label: "Contact Number",
          name: "phone_number",
          width: "15%",
        },
        {
          label: "Digital Product / Company Name",
          name: "title",
          width: "60%",
        },        
        {
          label: "Description",
          name: "description",
          width: "60%",
        },        
        {
          label: "Created By",
          name: "created_by",
          width: "60%",
        },        
        {
          label: "Actions",
          name: "",
          isSearch: false,
          isAction: true,
          width: "15%",
        },
      ],
      tableData: {
        draw: 0,
        length: 10,
        search: "",
        column: 0,
        dir: "desc",
        sortKey: "title",
        category_id: "", 
      },
      lang: {
        lengthMenu: this.$props.language.lengthMenu
          ? this.$props.language.lengthMenu
          : "Show_MENU_entries",
        info: this.$props.language.info
          ? this.$props.language.info
          : "Showing_FROM_to_TO_of_TOTAL_entries",
        zeroRecords: this.$props.language.zeroRecords
          ? this.$props.language.zeroRecords
          : "No data available in table.",
        search: this.$props.language.search ? this.$props.language.search : "Search",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: [],
      },  
      filter: { 
        category_id: "", 
      }, 
    };
  },

  setup() {
    const modalActive = ref(false);
    const modalActiveBarcode = ref(false);
    const modalShow = ref(false);
    const importModal = ref(false);
    const masterModal = ref(false); 
    return { modalActive, modalActiveBarcode, modalShow, importModal, masterModal };
  },
  beforeUnmount() {
    //this.editor.destroy()
  },
  mounted() {
    this.editor = new Editor({
      content: "<p>I’m running Tiptap with Vue.js. 🎉</p>",
      extensions: [StarterKit],
    });
  },
  methods: {
    toggleModal: function () {
      this.modalActive = !this.modalActive;
      if (!this.modalActive) {
        this.editMode = false;
        this.btn = "Create";
      }
      this.errors = "";
      this.isSubmit = false;
      this.form.reset();
    },
    toggleModal2: function () {
      this.modalShow = !this.modalShow;
    }, 
    toggleImportModal: function () {
      this.importModal = !this.importModal;
    },
    masterDataUploadModal: function () {
      this.masterModal = !this.masterModal;
    },  
    selectProduct(event) {
      this.forceRerender(); 
      this.product = this.items.find((e) => e.id == event);
      console.log("this.product", this.product);
    },
    print() {
      this.$htmlToPaper("barcodePrint");
    },
    edit: function (item) {
      this.btn='Update';
      this.editMode = true;
      this.toggleModal();
      this.form.fill(item); 
       
    },
    show: function (item) {
      axios.get(this.apiUrl + "/subscription_requests/" + item.id, this.headers)
        .then((res) => {
          if (res.status == 200) {
            this.items = res.data.data;
            this.modalShow = !this.modalShow;
          } else {
            this.$toast.error(res.data.message);
          } 
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message);
          if (err.response.status == 422) {
            this.errors = err.response.data.errors;
          }
        });
    },
    submitForm: function (e) {
      this.isSubmit = true;
      this.disabled = true;
      const formData = new FormData();  
      formData.append("title", this.form.title); 
      formData.append("description", this.form.description);  

      if (this.editMode) {
        formData.append("_method", "put");  
        var postEvent = axios.post(
          this.apiUrl + "/subscription_requests/" + this.form.id,
          formData,
          this.headers
        );
      } else {  
        var postEvent = axios.post(this.apiUrl + "/subscription_requests", formData, this.headers);
        console.log('formData',formData);
      }
      postEvent
        .then((res) => {
          this.isSubmit = false;
          this.disabled = false;
          if (res.status == 200) {
            this.toggleModal();
            this.$toast.success(res.data.message);
            //window.location.reload();
          } else {
            this.$toast.error(res.data.message);
          }
        })
        .catch((err) => {
          this.isSubmit = false;
          this.disabled = false;
          this.$toast.error(err.response.data.message);
          if (err.response.status == 422) {
            this.errors = err.response.data.errors;
          }
        })
        .finally((res) => {
          this.fetchItems();
        });
    },
    onkeyPress: function (field) {
      for (var k in this.errors) {
        // Loop through the object
        if (k == field) {
          // If the current key contains the string we're looking for 
          delete this.errors[k]; // Delete obj[key];
        }
      }
    },
    validateNumber: function (e, field) {
      const number = e.target.value;
      if (this.isNumber(number)) {
        this.form[field] = number;
        this.onkeyPress(this.form[field]);
      } else {
        this.form[field] = "";
      }
    },
    isNumber: function (value) {
      if (undefined === value || null === value) {
        return false;
      }
      if (typeof value == "number") {
        return true;
      }
      return !isNaN(value - 0);
    },
       
    deleteItem: function (item) {
      this.$swal({
        title: "Are you sure?",
        text: "You want delete this item!",
        showCancelButton: true,
        confirmButtonCategory: "#3085d6",
        cancelButtonCategory: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          axios
            .delete(this.apiUrl + "/subscription_requests/" + item.id, this.headers)
            .then((res) => {
              if (res.status == 200) {
                this.fetchItems();
                this.$toast.success(res.data.message);
              } else {
                this.$toast.error(res.data.message);
              }
              console.log(res.data);
            })
            .catch((err) => {
              this.$toast.error(err.response.data.message);
              if (err.response.status == 422) {
                this.errors = err.response.data.errors;
              }
            });
        } else {
          // this.$toast.error(`Hey! I'm here`);
          // this.$toast.warning(`Hey! I'm here`);
          // this.$toast.info(`Hey! I'm here`)
        }
      });
    },
    switchSelect(event) { 
    }, 
     
    // datatable For Pagination

    fetchItems(url = this.apiUrl + "/subscription_request/list") {
      this.tableData.draw++;
      axios
        .get(url, { params: this.tableData }, this.headerjson)
        .then((response) => {
          let data = response.data.data;
          if ((this.tableData.draw = data.draw)) {
            this.items = data.data.data; 
            this.configPagination(data.data);
          }
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally((fres) => {
          this.loading = false;
        });
    }, 

    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total ? data.total : 0;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from ? data.from : 0;
      this.pagination.to = data.to ? data.to : 0;
      this.pagination.links = data.links;
    },

    sortBy(key, sortable) {
      this.tableData.sortKey = key; 
      this.tableData.column = this.getIndex(this.columns, "name", key);
      this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc';
      this.fetchItems();
    },
    setPage(data) {
      this.fetchItems(data.url);
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },

    filterData() { 
      this.fetchItems();
    }, 
    // datatable For Pagination
  },
  async created() { 
    await this.fetchItems();    
  },
  destroyed() {},
  mounted() {
    window.scrollTo(0, 0);
  },
  computed: {},
};
</script>
<style>
.thumbnail-img {
  display: block;
  margin-top: 4px;
}
.font-size-20{
  font-size:20px
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-11 {
    width: 91.66666666666666%;
  }
  .col-sm-10 {
    width: 83.33333333333334%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-8 {
    width: 66.66666666666666%;
  }
  .col-sm-7 {
    width: 58.333333333333336%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-5 {
    width: 41.66666666666667%;
  }
  .col-sm-4 {
    width: 33.33333333333333%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-2 {
    width: 16.666666666666664%;
  }
  .col-sm-1 {
    width: 8.333333333333332%;
  }
}
</style>
<style scoped>
.btn-file {
  overflow: hidden;
  position: relative;
  vertical-align: middle;
}
.modal-content.scrollbar-width-thin {
  border: none !important;
}
label {
  display: inline-block;
  margin: 0px 0px 4px 2px;
  float: left;
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  text-align: left;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}
 
.multiselect-tag.is-user {
  padding: 5px 8px;
  border-radius: 22px;
  background: #35495e;
  margin: 3px 3px 8px;
}

.multiselect-tag.is-user img {
  width: 18px;
  border-radius: 50%;
  height: 18px;
  margin-right: 8px;
  border: 2px solid #ffffffbf;
}

.multiselect-tag.is-user i:before {
  color: #ffffff;
  border-radius: 50%;
}

.user-image {
  margin: 0 6px 0 0;
  border-radius: 50%;
  height: 22px;
}
.multiselect-clear {
  display: inline-block !important;
  float: right !important;
}
.multiselect {
  display: block;
  position: relative;
}
.multiselect.is-active {
  z-index: 1;
}

.modal-content.scrollbar-width-thin.product-show-modal {
  width: 700px;
  margin: auto;
}
.modal-content.scrollbar-width-thin.product-upload-modal {
  width: 400px;
}
.modal-content.scrollbar-width-thin.product-add-modal {
  width: 95% !important;
  margin: 0px auto;
}
.modal-content.scrollbar-width-thin.product-barcode-modal {
  max-width: 900px;
  min-width: 800px;
  margin: 0px auto;
}
</style>
<style src="@vueform/multiselect/themes/default.css"></style>
